import React from "react";

const HtmlReader = ({html}) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default HtmlReader;
